import { TicketType } from 'features/common/types';

import { Text } from './TicketRow.styles';

export const TicketRow = ({ quantity, ID, name }: TicketType, isPunchup?: boolean) =>
	quantity > 0 && <Text key={ID} isPunchup={isPunchup}>{`${name} (${quantity})`}</Text>;
